<template>
  <div>
    <div>
      <Sale
        v-model="sale"
        class="detail-query"
        @change="handleSaleChange"
      />

      <SummaryDateSelect
        v-model="summaryDate"
        class="detail-query"
        @change="hadnleSummaryDateChange"
      />

      <DatePickerContrast
        class="detail-query"
        :defaultDate="date"
        :isContrast.sync="isDateContrast"
        @change="handleDateChange"
      />

      <Button
        type="primary"
        @click="handleRefresh"
      >
        刷新数据
      </Button>
    </div>

    <Tabs
      v-model="tab"
      style="margin-top: 40px"
      @tab-click="handleTabClick"
    >
      <TabPane
        label="趋势分析"
        name="1"
      >
        <div class="detail-field">
          <div v-if="fieldType === '1'">
            <span style="font-size: 14px">展示指标：</span>
            <ContrastSelect
              v-model="field"
              :baseList="fieldList"
              :contrastList="fieldList"
              :isContrast.sync="isFieldContrast"
              defaultContrast="impression_total"
              @change="handleFieldChange"
            />
          </div>
          <div
            v-else
            style="flex: 1"
          /> 
          <RadioGroup
            v-model="fieldType"
            @change="handleFieldTypeChange"
          >
            <RadioButton label="1">汇总</RadioButton>
            <RadioButton label="2">TOP10</RadioButton>
          </RadioGroup>
        </div>
      </TabPane>
      <TabPane
        label="占比分析"
        name="2"
      >
        <span style="font-size: 14px">占比维度：</span>
        <Select
          v-model="dimension"
          style="margin-right: 20px"
          @change="handleDimensionChange"
        >
          <Option
            v-for="item in dimensionList"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          />
        </Select>
        <span style="font-size: 14px">展示指标：</span>
        <ContrastSelect
          v-model="field"
          :baseList="fieldList"
          :contrastList="fieldList"
          :isContrast.sync="isFieldContrast"
          defaultContrast="impression_total"
          @change="handleFieldChange"
        />
      </TabPane>
    </Tabs>

    <div
      v-loading="chartLoading"
      style="margin-top: 20px"
    >
      <Chart
        :type="tab"
        :lineType="fieldType"
        :dataSource="chartData"
      />
    </div>

    <Title text="详细数据" />

    <div v-loading="tableLoading">
      <CustomTable
        topic="direct_sale"
        :args="downloadArgs"
        :dataSource="rawTableData"
        :customColumns="customColumns"
        :fixedColumns="fixedColumns"
        @created="handleCustomTableCreated"
        @download="handleCustomTableDownload"
        @change-columns="handleCustomTableColumnsChange"
        @current-change="handleCustomTableCurrentChange"
        @size-change="handleCustomTableSizeChange"
        @sort-change="handleCustomTableSortChange"
      >
        <template v-slot:column="{ data: d }">
          {{ getDateFormat(d) }}
        </template>
      </CustomTable>
    </div>
  </div>
</template>

<script>
import {
  Button,
  Tabs,
  TabPane,
  Select,
  Option,
  RadioGroup,
  RadioButton,
} from 'element-ui';
import moment from 'moment';

import Sale from '../components/Sale/Index';
import SummaryDateSelect from '@/components/SummaryDateSelect/Index';
import DatePickerContrast from '@/components/DatePicker/Contrast';
import ContrastSelect from '@/components/ContrastSelect/Index';
import Chart from './components/Chart/Index';
import Title from '@/components/Title';
import CustomTable from '@/components/CustomTable/Index';

import shortcuts from '@/config/shortcuts';
import requestMixin from './mixins/request';
import { fields, dimensions, customColumns, fixedColumns } from './config/';
import { getFieldsByList } from '@/config/columns/';
import * as $cache from '@/common/cache';

export default {
  components: {
    Button,
    Tabs,
    TabPane,
    Select,
    Option,
    RadioGroup,
    RadioButton,

    Sale,
    SummaryDateSelect,
    DatePickerContrast,
    ContrastSelect,
    Chart,
    Title,
    CustomTable,
  },

  mixins: [requestMixin],

  data() {
    const { saleId, departmentId, date } = this.$route.query;
    const _sale = [];
    if (departmentId) _sale.push(departmentId);
    if (saleId) _sale.push(saleId);

    return {
      // 销售
      sale: _sale,
      // 汇总时间
      summaryDate: 'day',
      // 日期
      date: date ? this.getDate(date) : shortcuts.last7Days.data,
      compareDate: null,
      // 是否开启时间对比
      isDateContrast: false,

      // 当前分析类型
      tab: '1',
      // 展示指标
      field: ['cost_total'],
      // 展示指标列表
      fieldList: getFieldsByList(fields),
      // 图表类型
      fieldType: '1',
      // 是否开启展示指标对比
      isFieldContrast: false,
      // 维度
      dimension: 'department',
      // 维度列表
      dimensionList: getFieldsByList(dimensions),
      // 图表数据
      chartData: {},
      chartLoading: false,

      // 页码
      page: 1,
      page_size: 10,
      customColumns,
      fixedColumns,
      rawTableData: {},
      fields: [],
      tableLoading: false,
      order_by: '',
    };
  },

  computed: {
    // 用户信息
    user() {
      return this.$store.state.userInfo;
    },

    downloadArgs() {
      const params = this.getParams();
      params.dimension = this.summaryDate;
      params.page = this.page;
      params.page_size = this.page_size;
      params.fields = this.fields.join(',');
      params._login_token = ($cache.localGet($cache.AUTH) || {}).token || '';
      return params;
    },
  },

  created() {
    // const { department_id, id } = this.user;
    // this.sale = [department_id, id];
    this.queryDirectChart();
  },

  methods: {
    getDateFormat(d) {
      if (d.field.key === 'date') {
        return d.row.date.split(' ')[0];
      }
      return d.row[d.field.key];
    },

    handleSaleChange() {
      this.page = 1;
      this.queryChartData();
      this.queryDirectList();
    },

    hadnleSummaryDateChange() {
      this.page = 1;
      this.queryChartData();
      this.queryDirectList();
    },

    handleDateChange(data) {
      this.page = 1;
      this.date = data[0];
      this.compareDate = data[1];
      if (data[1]) {
        this.isFieldContrast = false;
        this.field[1] = '';
      }
      this.queryChartData();
      this.queryDirectList();
    },

    handleRefresh() {
      this.page = 1;
      this.queryChartData();
      this.queryDirectList();
    },

    // 切换 tab
    handleTabClick() {
      if (this.tab === '1') {
        if (this.fieldType === '2') {
          this.isFieldContrast = false;
          this.field[1] = '';
        }
      }
      this.queryChartData();
    },

    handleFieldTypeChange() {
      if (this.fieldType === '2') {
        this.isDateContrast = false;
        this.compareDate = null;
        this.isFieldContrast = false;
        this.field[1] = '';
      }
      this.queryChartData();
    },

    handleFieldChange(data) {
      if (data[1]) {
        this.isDateContrast = false;
        this.compareDate = null;
      }
      this.queryChartData();
    },

    handleDimensionChange() {
      this.queryChartData();
    },

    handleCustomTableCreated(fields) {
      this.page = 1;
      this.fields = fields;
      this.queryDirectList();
    },

    // 表格下载
    handleCustomTableDownload() {
      this.download();
    },

    // 变更自定义列
    handleCustomTableColumnsChange(fields) {
      this.page = 1;
      this.fields = fields;
      this.queryDirectList();
    },

    // 更改页码
    handleCustomTableCurrentChange(current) {
      this.page = current;
      this.queryDirectList();
    },

    // 更改每页数量
    handleCustomTableSizeChange(size) {
      this.page_size = size;
      this.queryDirectList();
    },

    queryChartData() {
      if (this.tab === '1') {
        if (this.fieldType === '1') {
          this.queryDirectChart();
        } else if (this.fieldType === '2') {
          this.queryDirectChartTop10();
        }
      } else if (this.tab === '2') {
        this.queryDirectPie();
      }
    },

    getDate(date) {
      const weekday = moment().weekday();
      if (date === 'thisWeek') {
        return weekday === 1
          ? []
          : [
              moment().weekday(weekday === 0 ? weekday - 6 : 1),
              moment()
                .weekday(moment().weekday())
                .subtract(1, 'day'),
            ];
      } else if (date === 'thisMonth') {
        if (
          moment() <
          moment()
            .startOf('month')
            .add(1, 'day')
        ) {
          return [];
        }
        return [moment().startOf('month'), moment().subtract(1, 'day')];
      } else {
        return shortcuts[date].data;
      }
    },

    handleCustomTableSortChange(data) {
      this.order_by = data;
      this.queryDirectList();
    },
  },
};
</script>

<style lang="less" scoped>
.detail {
  &-query {
    margin: 0px 20px 20px 0;
  }

  &-field {
    display: flex;
    justify-content: space-between;
  }
}
</style>